import { Component } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { ForgotPasswordService } from './forgot-password.service';
import { CommonModule } from '@angular/common';
import Swal from 'sweetalert2'; // Import SweetAlert2

@Component({
  selector: 'app-forgot-password',
  standalone: true,
  imports: [TranslateModule, CommonModule, ReactiveFormsModule],
  templateUrl: './forgot-password.component.html',
  styleUrl: './forgot-password.component.scss'
})
export class ForgotPasswordComponent {

  submitted = false;
  forgotPasswordForm = new FormGroup({
    email: new FormControl('', [Validators.required, Validators.email]),
  });

  constructor(
    private forgotPasswordService: ForgotPasswordService,
    private toastr: ToastrService,
    private translateService: TranslateService,
    private router: Router
  ) {}

  ngOnInit(): void {
  }

  onSubmit() {
    this.submitted = true;
    if (this.forgotPasswordForm.invalid) {
      return;
    }

    const email = this.forgotPasswordForm.value.email!;
    const lang = localStorage.getItem('locale') ?? 'en';

    this.forgotPasswordService.forgotPassword(email, lang).subscribe({
      next: (res: any) => {
        if (res.success) {
          Swal.fire({
            icon: 'success',
            title: this.translateService.instant('Success!'),
            text: this.translateService.instant(res.message),
            confirmButtonText: this.translateService.instant('OK'),
          }).then(() => {
            this.submitted = false;
            //this.router.navigate(['/login']);
          });
        } else {
          this.submitted = false;
          Swal.fire({
            icon: 'error',
            title: this.translateService.instant('Error!'),
            text: this.translateService.instant(res.message),
            confirmButtonText: this.translateService.instant('OK'),
          });
        }
      },
      error: (err) => {
        this.submitted = false;
        Swal.fire({
          icon: 'error',
          title: this.translateService.instant('Error!'),
          text: this.translateService.instant('An error occurred. Please try again.'),
          confirmButtonText: this.translateService.instant('OK'),
        });
      },
    });
  }

  goToLoginPage() {
    this.router.navigate(['/login']);
  }


}
